


















































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import SideNavVue from "../components/Declaration/SideNav.vue";

import { mapGetters } from "vuex";
interface newRow {
    item: string,
    itemType: string,
    itemDetail: string,
    payableBase: number | string | null,
    payableBaseDeduction: number | string | null,
    billingBasis: number | string | null,
    levyNormal: number | string | null,
    deduction: number | string | null,
    levyProportion: number,
    currentNeedPay: number | string | null,
    deductionFee: number | string | null,
    codeDeduction: number | string | null,
    currentFeePaid: number | string | null,
    finalNeedPay: number | string | null,
}
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "side-nav": SideNavVue,
    },
})
export default class LandUseTax extends Vue {
    activeTab: string = "LandUseTax"
    changeSide() {
        // this.resetNewRow()
        this.init()
        this.fetchData()
    }
    changeTable3(row?: any, name?: any) {
        if (name === "time") {
            if (row.date != "") {
                row.date = this.$utils.simpleDateFormat(row.date, "d");
            }
        }
        const taxCopy = JSON.parse(JSON.stringify(row));
        Vue.axios
            .post(
                `land/use/tax/info/save`,
                taxCopy
            )
            .then(() => {
                this.fetchData();
            });
    }
    delTable3(id: number) {
        const taxCopy = JSON.parse(JSON.stringify(this.tax));
        Vue.axios
            .post(
                `land/use/tax/info/delete?id=${id}`,
            )
            .then(() => {
                this.fetchData();
            });
    }
    tableList: any = []
    addNewRow3() {
        if (this.$utils.notNull([
            this.newInfo.no,
        ]) || this.$utils.notNull([
            this.newInfo.landParcelNo,
        ]) || this.$utils.notNull([
            this.newInfo.name,
        ])
            || this.$utils.notNull([
                this.newInfo.type,
            ])
            || this.$utils.notNull([
                this.newInfo.date,
            ])
            || this.$utils.notNull([
                this.newInfo.socialCreditCode,
            ])
            || this.$utils.notNull([
                this.newInfo.useName,
            ])
            || this.$utils.notNull([
                this.newInfo.certificateNumber,
            ])
            || this.$utils.notNull([
                this.newInfo.landNature,
            ])
            || this.$utils.notNull([
                this.newInfo.purpose,
            ]
                || this.$utils.notNull([
                    this.newInfo.getWay,
                ]
                    || this.$utils.notNull([
                        this.newInfo.floorSpace,
                    ] || this.$utils.notNull([
                        this.newInfo.city,
                    ])
                        || this.$utils.notNull([
                            this.newInfo.street,
                        ])
                        || this.$utils.notNull([
                            this.newInfo.address,
                        ])
                        || this.$utils.notNull([
                            this.newInfo.taxOffice,
                        ])
                    )
                )
            )
        ) {
            if (this.newInfo.date != "" && this.newInfo.date != null) {
                this.newInfo.date = this.$utils.simpleDateFormat(this.newInfo.date, "d");
            }
            this.$nextTick(() => {
                this.changeTable3(this.newInfo)
                this.$nextTick(() => {
                    this.init()
                })
            })
        } else {
            this.$message.warning("亲，请填写完整数据！");

        }
    }
    newInfo: any = {
        accountBookId: this.$store.state.accountBook.id,
        no: "",
        landParcelNo: "",
        name: "",
        type: "",
        socialCreditCode: "",
        useName: "",
        certificateNumber: "",
        landNature: "",
        purpose: "",
        date: "",
        getWay: "",
        floorSpace: "",
        city: "",
        street: "",
        address: "",
        taxOffice: "",
    }
    mainBodyList = [
        { id: 1, name: "增值税小规模纳税人" },
        { id: 2, name: "小型微利企业（增值税一般纳税人）" },
        { id: 3, name: "个体工商户（增值税一般纳税人）" },
    ]
    typeList = [
        { id: 1, name: "土地使用权人" },
        { id: 2, name: "集体土地使用人" },
        { id: 3, name: "无偿使用人" },
        { id: 4, name: "代管人" },
        { id: 5, name: "实际使用人" },
    ]
    nameList = [
        { id: 1, name: "划拨" },
        { id: 2, name: "出让" },
        { id: 3, name: "租赁" },
        { id: 4, name: "其他" },
        { id: 5, name: "转让" },
    ]
    ytList = [
        { id: 1, name: "商业用地" },
        { id: 2, name: "综合用地" },
        { id: 3, name: "居住用地" },
        { id: 4, name: "工业用地" },
        { id: 5, name: "房地产开发企业的开发用地" },
        { id: 6, name: "其他用地" },
    ]
    tax: any = {};
    stampTaxList: any = [];
    newRow = {
        no: "",
        landParcelNo: "",
        totalArea: "",
        areaLevel: "",
        taxationBasis: "",
        taxStandard: "",
        needPay: "",
        codeDeduction: "",
        deductionTaxRate: "",
        taxPaid: "",
        finalNeedPay: "",
    };
    period: string = "";
    time: string = "";
    getMonth() {
        let data = this.$store.state.accountBook.taxFormDto.taxInfoMap
        Object.keys(data).forEach((attr) => {
            if (attr === "城镇垃圾处理费") {
                if (data[attr].taxInfoMethod === 1) return false
                else return true
            }

        });
    }
    mounted() {
        this.getMonth()
    }
    // 切换纳税申报表
    changeType(val: number) {
        if (val === 1) this.fetchData();
        else this.$router.push({ path: "/declaration" });
    }
    init() {
        this.newRow = {
            no: "",
            landParcelNo: "",
            totalArea: "",
            areaLevel: "",
            taxationBasis: "",
            taxStandard: "",
            needPay: "",
            codeDeduction: "",
            deductionTaxRate: "",
            taxPaid: "",
            finalNeedPay: "",
        };
        this.newInfo = {
            accountBookId: this.$store.state.accountBook.id,
            no: "",
            landParcelNo: "",
            name: "",
            type: "",
            socialCreditCode: "",
            useName: "",
            certificateNumber: "",
            landNature: "",
            purpose: "",
            date: "",
            getWay: "",
            floorSpace: "",
            city: "",
            street: "",
            address: "",
            taxOffice: "",
        }
    }
    // 选择时间
    changeDate(start: string, end: string) {
        let data = this.$store.state.accountBook.taxFormDto.taxInfoMap
        Object.keys(data).forEach((attr) => {
            if (attr === "城镇土地使用税") {
                if (data[attr].taxInfoMethod === 1) {
                    this.period = start
                }
                else {
                    this.period = end
                }
            }

        });
        this.init()
        this.fetchData();
    }
    //   createStateFilter(queryString:string) {
    //     let state = this.newRow.payableBaseDeduction
    //     return (state:any) => {
    //       return (state.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //     };
    //   }
    fetchData() {
        if (this.activeTab == "LandUseTaxInfo") {
            Vue.axios
                .get(
                    `land/use/tax/info/find?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`
                )
                .then((res) => {
                    this.tableList = res.data
                });
        }
        else {
            Vue.axios
                .get(
                    `land/use/tax?accountBookId=${this.$store.state.accountBook.id}&period=${this.period}`
                )
                .then((res) => {
                    this.tax = res.data
                    this.stampTaxList = res.data.landUseTaxRowDtoList;
                    this.time =
                        this.tax.startPeriod.substring(0, 4) +
                        "年" +
                        this.tax.startPeriod.substring(4) +
                        "月" +
                        "至" +
                        this.tax.endPeriod.substring(0, 4) +
                        "年" +
                        this.tax.endPeriod.substring(4) +
                        "月";
                });
        }
    }
    changeRow(row?: any, name?: string) {
        if (name === "deductionTaxRate" || name === "totalArea" || name === "taxStandard") row.changeTypeName = name
        Vue.axios
            .post(
                `land/use/tax`,
                this.tax
            )
            .then((res) => {
                this.fetchData();
            });
    }
    addRow() {
        if (
            (this.newRow.no != "") &&
            (this.newRow.totalArea != "") && (this.newRow.areaLevel != "")
        ) {
            this.stampTaxList.push(this.newRow);
            this.init()
            this.tax.landUseTaxRowDtoList = this.stampTaxList;
            this.changeRow();
        } else {
            this.$message.warning("亲，请填写完整数据！");
        }
    }
    remove(index: number) {
        if (this.tax.landUseTaxRowDtoList.length === 1) {
            this.tax.landUseTaxRowDtoList = [];
        } else {
            this.tax.landUseTaxRowDtoList.splice(index, 1);
        }
        this.changeRow();
    }
}
